import React from 'react';
import { Col, Row } from 'antd';
import Wrapper from '../LandingBlockWrapper/BlockWrapper';
import Flexbox from 'flexbox-react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';


import icon1 from '../../assets/icons/13.svg';
import icon2 from '../../assets/icons/12.svg';
import icon3 from '../../assets/icons/14.svg';
import icon4 from '../../assets/icons/15.svg';
import icon5 from '../../assets/icons/16.svg';
import icon6 from '../../assets/icons/17.svg';

const list = [
	[
		{
			icon: icon1,
			title: <FormattedMessage {...messages.titleIcon1} />,
			label: <FormattedMessage {...messages.labelIcon1} />,
		}, {
		icon: icon2,
		title: <FormattedMessage {...messages.titleIcon2} />,
		label: <FormattedMessage {...messages.labelIcon2} />,
	}, {
		icon: icon3,
		title: <FormattedMessage {...messages.titleIcon3} />,
		label: <FormattedMessage {...messages.labelIcon3} />,
	}],
	[
		{
			icon: icon4,
			title: <FormattedMessage {...messages.titleIcon4} />,
			label: <FormattedMessage {...messages.labelIcon4} />,
		}, {
		icon: icon5,
		title: <FormattedMessage {...messages.titleIcon5} />,
		label: <FormattedMessage {...messages.labelIcon5} />,
	}, {
		icon: icon6,
		title: <FormattedMessage {...messages.titleIcon6} />,
		label: <FormattedMessage {...messages.labelIcon6} />,
	}],
];

const Item = ({ list, index }) => [
	<Col key={`index_${index}`} sm={24} xs={24} md={24} lg={8} className='Item'>
		{list.map(({ icon, label, title }, i) =>
			(<div key={i}>
				<img alt={'icon'} src={icon} style={{ float: index % 2 ? 'right' : 'left' }}/>
				<div style={{ textAlign: index % 2 ? 'right' : 'left' }}>
					<h4>{title}</h4>
					<span>{label}</span>
				</div>
			</div>),
		)}
	</Col>,
	index === 1 ? <Col key={`index_1${index}`} sm={24} xs={24} md={24} lg={8} className="Device"><div></div></Col> : null
];

export default () => (
	<Wrapper className="Features">
		<Flexbox flexDirection="column">
			<Row>
				<Col>
					<h2><FormattedMessage {...messages.title} /></h2>
				</Col>
			</Row>
			<Row className="block">
				{list.map((l, i) => <Item key={i} index={i + 1} list={l}/>)}
			</Row>
		</Flexbox>
	</Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/LandingFeatures/Features.js